import React from "react"
import ToggleButtonGroup, {
  ToggleButtonGroupProps,
} from "@mui/material/ToggleButtonGroup"
import ToggleButton from "@mui/material/ToggleButton"

interface ItemType {
  id: number
  label: string
  value: string
}

type Props = ToggleButtonGroupProps & {
  items: ItemType[]
}

const ToggleComponent = ({ items, ...restProps }: Props) => {
  return (
    <ToggleButtonGroup
      exclusive
      fullWidth
      color="secondary"
      size="medium"
      {...restProps}
    >
      {items.map(({ value, label }: ItemType, index: number) => (
        <ToggleButton key={index} value={value}>
          {label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  )
}

export default ToggleComponent
